// ¿El navegador pinta SIN aceleración por GPU? (escritorio remoto/VDI, GPU bloqueada, máquinas virtuales; también
// el Chromium headless de las pruebas). Ahí la aurora del lienzo —5 orbes con blur(90px) que se mueven— obliga a
// rasterizar cada cuadro en el procesador: medido, ~230 ms por cuadro (la plataforma entera a 4 cuadros por
// segundo y cada clic tarda 0.8–1.5 s en pintarse). Con GPU el mismo cambio de tema pinta en ~40 ms.
//
// Si no hay GPU, <html> lleva la clase `db-sin-gpu` (shell/shell.css): la aurora se queda quieta (como con «reducir
// movimiento»), el vidrio pasa a superficie sólida (como con «reducir transparencia») y el interruptor de tema
// cambia sin la transición de revelado (View Transitions captura la página completa: ~100 ms más sin GPU).
//
// `failIfMajorPerformanceCaveat` es la señal estándar: el contexto WebGL no se crea si sólo habría render por
// software. Se revisa una vez, cuando el navegador está libre (no retrasa el primer cuadro).
const CLASE = 'db-sin-gpu';
let sinGpu = null;
let enCurso = null;

function detectar() {
  try {
    const lienzo = document.createElement('canvas');
    const gl = lienzo.getContext('webgl', { failIfMajorPerformanceCaveat: true })
      || lienzo.getContext('experimental-webgl', { failIfMajorPerformanceCaveat: true });
    if (!gl) return true;
    const info = gl.getExtension('WEBGL_debug_renderer_info');
    const renderer = info ? String(gl.getParameter(info.UNMASKED_RENDERER_WEBGL)) : '';
    gl.getExtension('WEBGL_lose_context')?.loseContext();
    return /swiftshader|llvmpipe|softpipe|software|basic render/i.test(renderer);
  } catch {
    return false; // ante la duda, el diseño completo
  }
}

/** true | false | null (todavía no se sabe). */
export function renderSinGpu() {
  return sinGpu;
}

/** Revisa una vez y marca <html>. Devuelve una promesa con el resultado. */
export function prepararGraficos() {
  if (sinGpu !== null || typeof window === 'undefined') return Promise.resolve(sinGpu);
  if (enCurso) return enCurso;
  enCurso = new Promise((resolver) => {
    const correr = () => {
      sinGpu = detectar();
      document.documentElement.classList.toggle(CLASE, sinGpu);
      resolver(sinGpu);
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(correr, { timeout: 600 });
    else setTimeout(correr, 50);
  });
  return enCurso;
}
